import React from 'react';
import { serializeStyles } from '@emotion/serialize';
import { StyleSheet } from '@emotion/sheet';
import { serialize, compile, middleware, rulesheet, stringify } from 'stylis';

// From: https://github.com/emotion-js/emotion/issues/2131
function injectGlobal(args) {
	// Evaluate if args is string or object style
	args = typeof args === 'string' ? args : [args];
	const { name, styles } = serializeStyles(args);
	const sheet = new StyleSheet({
		key: `global-${name}`,
		container: document.head,
	});

	const stylis = (styles) =>
		serialize(
			compile(styles),
			middleware([
				stringify,
				rulesheet((rule) => {
					sheet.insert(rule);
				}),
			])
		);
	stylis(styles);
	return () => sheet.flush();
}

export const Global = ({ styles }) => {
	React.useEffect(() => {
		const removeStyles = injectGlobal(styles);
		return () => removeStyles();
	}, [styles]);
	return null;
};
